import './Ticket.css';

function ImagePreviewGallery({ setSelectedImg, images }) {
  return (
    <div className="image-preview-gallery">
      {images.length > 0 ? (
        images.map((item) => (
          <div
            className="image-preview"
            key={item.id}
            onClick={() => setSelectedImg(item.url)}
          >
            <img src={item.url} alt="img" />
          </div>
        ))
      ) : (
        <p style={{ width: '200px' }}>Nema priloženih fajlova.</p>
      )}
    </div>
  );
}

export default ImagePreviewGallery;
